import { minutesInHour, secondsInMinute } from 'helpers/timeConsts';

export default function getHoursMinFormat(secondsValue: number) {
  const isNegative = secondsValue < 0;
  const absSecondsValue = Math.abs(secondsValue);
  const minutesValue = Math.floor(absSecondsValue / secondsInMinute);
  const hours = Math.floor(minutesValue / minutesInHour);
  const minutes = Math.abs(minutesValue % minutesInHour);

  const formatMinutes = (minutesToFormat: number) =>
    String(minutesToFormat).padStart(2, '0');

  const prefix = isNegative ? '-' : '';

  return `${prefix}${hours}:${formatMinutes(minutes)}`;
}
